<div class="main-container" *ngIf="sections[0] && currentlyVisibleSection === 0 && !isDataLoading"
	[class.disabled]="currentlyVisibleSection > 0 || isDataLoading" @fadeIn>
	<div class="site-wrapper">
		<div class="site-name-wrapper">
			<ng-container
				*ngTemplateOutlet="binderWizardDetails.accountSiteName ? infoTemplate : null; context: { label: 'Site Name', text: binderWizardDetails.accountSiteName }">
			</ng-container>
		</div>
		<div>
			<button mat-button color="primary" (click)="onChangeSite()">Change site</button>
		</div>
	</div>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.accountSiteResourceName ? infoTemplate : null; context: { label: 'Asset Name', text: binderWizardDetails.accountSiteResourceName }">
	</ng-container>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Binder Name', text: binderWizardDetails.binderName }">
	</ng-container>

	<ng-container *ngIf="binderWizardDetails.isBinderDisabled">
		<div class="disabled-binder">
			<p class="centered">
				This QR access code has been disabled. Please contact your administrator.
			</p>
		</div>
	</ng-container>

	<ng-container *ngIf="!binderWizardDetails.isBinderDisabled">
		<div class="main-form">
			<form [formGroup]="binderFormGroup" (keyup)="keyPressed($event)">
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput formControlName="email" [disabled]="currentlyVisibleSection > 0 || isDataLoading"
						autocomplete="on" name="email" />
				</mat-form-field>

				<div class="work-to-do">
					<mat-checkbox formControlName="hasWorkToDo"></mat-checkbox>
					<div>
						<span>I have Work to do</span>
						<span class="details">(only granted to verified accounts)</span>
					</div>
				</div>

				<div class="form-button-container">
					<button mat-raised-button type="button" (click)="isBinderAndCustomerLegacy()"
						[disabled]="binderFormGroup.invalid || currentlyVisibleSection > 0 || isDataLoading">Submit</button>
				</div>
			</form>
		</div>
	</ng-container>
</div>

<div class="main-container centered" *ngIf="sections[2] && currentlyVisibleSection === 2 && !isDataLoading"
	[class.disabled]="currentlyVisibleSection > 1 || isDataLoading" @fadeIn>
	<p class="centered">
		An email was sent to <span style="color:#a8a8b0">{{ binderFormGroup.get('email').value }}</span>
		with an access link to
		<br>
		{{ binderWizardDetails.binderName }} for Site
		{{ binderWizardDetails.accountSiteName }}
		<span *ngIf="binderWizardDetails.accountSiteResourceName"> and asset {{
			binderWizardDetails.accountSiteResourceName }}</span>
	</p>
</div>

<div class="main-container error-page" *ngIf="sections[SectionsEnum.Error] && currentlyVisibleSection === SectionsEnum.Error && !isDataLoading" @fadeIn>
	<div class="site-wrapper">
		<div class="site-name-wrapper">
			<ng-container
				*ngTemplateOutlet="binderWizardDetails.accountSiteName ? infoTemplate : null; context: { label: 'Site Name', text: binderWizardDetails.accountSiteName }">
			</ng-container>
		</div>
	</div>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Binder Name', text: binderWizardDetails.binderName }">
	</ng-container>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Email', text: binderFormGroup.get('email')?.value }">
	</ng-container>

	<div class="public-view" *ngIf="!!publicViewingMessage">
		<span>Public View</span>
		<hr>
		<span class="red">{{publicViewingMessage}}</span>
	</div>

	<div class="error-message">
		<span>{{errorMessage}}</span>
	</div>

	<div class="back-to-binder-button">
		<button mat-raised-button type="button" (click)="backToBinderRequest()">Go Back to Binder request</button>
	</div>
</div>

<!-- has geo fencing token disabled -->
<div class="main-container error-page" *ngIf="sections[4] && currentlyVisibleSection === 4 && !isDataLoading" @fadeIn>
	<div class="site-wrapper">
		<div class="site-name-wrapper">
			<ng-container
				*ngTemplateOutlet="binderWizardDetails.accountSiteName ? infoTemplate : null; context: { label: 'Site Name', text: binderWizardDetails.accountSiteName }">
			</ng-container>
		</div>
	</div>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Binder Name', text: binderWizardDetails.binderName }">
	</ng-container>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Email', text: binderFormGroup.get('email')?.value }">
	</ng-container>

	<ng-container *ngIf="isTokenEnabledFlow; else is_geoFencing_flow">
		<div class="assist-message">
			Please contact Customer Support at <strong>833.848.1100</strong> to assist with generating an individual
			alternative <strong>token</strong> for binder access.
		</div>
		<div class="token-wrapper">
			<div class="token-label">Access Token:</div>
			<div class="token-box">
				<mat-form-field>
					<input matInput [(ngModel)]="accessToken">
				</mat-form-field>
			</div>
		</div>
		<div class="back-to-binder-button">
			<button mat-raised-button type="button" color="primary" (click)="checkCustomerSupportToken()">Continue</button>
		</div>
	</ng-container>
	<ng-template #is_geoFencing_flow>
		<div class="public-view">
			<span>GeoFence Validation</span>
			<hr>
			<span class="red">Failed</span>
		</div>
	
		<div *ngIf="hasGeoFencingTokenDisabled; else has_geoFencing_enabled">
			<div class="public-view">
				<span>Alternative token access</span>
				<hr>
				<span>not allowed</span>
			</div>
			<div class="error-message">
				<div>Current Binder requires GeoFencing validations and your device is either not able to report your
					location
					or you are not within the allowed perimeter.</div>
				<div class="additional-info">Please contact customer support at Vitralogy for more info.</div>
			</div>
			<div class="back-to-binder-button">
				<button mat-raised-button type="button" color="primary" (click)="backToBinderRequest()">Go Back to Binder
					request</button>
			</div>
		</div>
		<ng-template #has_geoFencing_enabled>
			<div class="error-message">
				Current binder requires GeoFencing validations and your device is either not able to report your location or
				you are not within the allowed perimeter.
			</div>
			<div class="assist-message">
				Please contact Customer Support at <strong>833.848.1100</strong> to assist with generating an individual
				alternative <strong>token</strong> for binder access.
			</div>
			<div class="token-wrapper">
				<div class="token-label">Access Token:</div>
				<div class="token-box">
					<mat-form-field>
						<input matInput [(ngModel)]="accessToken">
					</mat-form-field>
				</div>
			</div>
			<div class="back-to-binder-button">
				<button mat-raised-button type="button" color="primary" (click)="checkCustomerSupportToken()">Continue</button>
			</div>
		</ng-template>
	</ng-template>
</div>
<!-- customer token invalid -->
<div class="main-container error-page" *ngIf="sections[5] && currentlyVisibleSection === 5 && !isDataLoading" @fadeIn>
	<div class="site-wrapper">
		<div class="site-name-wrapper">
			<ng-container
				*ngTemplateOutlet="binderWizardDetails.accountSiteName ? infoTemplate : null; context: { label: 'Site Name', text: binderWizardDetails.accountSiteName }">
			</ng-container>
		</div>
	</div>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Binder Name', text: binderWizardDetails.binderName }">
	</ng-container>

	<ng-container
		*ngTemplateOutlet="binderWizardDetails.binderName ? infoTemplate : null; context: { label: 'Email', text: binderFormGroup.get('email')?.value }">
	</ng-container>

	<div *ngIf="isGeoFencingValidationFailed; else geoFencing_not_checked">
		<div class="public-view">
			<span>GeoFence Validation</span>
			<hr>
			<span class="red">Failed</span>
		</div>
		<div class="error-message">
			Current binder requires GeoFencing validations and your device is either not able to report your location or you are not within the allowed perimeter.
		</div>
		<div class="assist-message">
			Please contact Customer Support at <strong>833.848.1100</strong> to assist with generating an individual alternative <strong>token</strong> for binder access.
		</div>
		<div class="token-wrapper">
			<div class="token-label">Access Token:</div>
			<div class="token-box">
				<mat-form-field>
					<input matInput [(ngModel)]="accessToken" autocomplete="off">
				</mat-form-field>
			</div>
		</div>
	</div>
	<ng-template #geoFencing_not_checked>
		<div class="token-wrapper">
			<div class="token-label">Access Token:</div>
			<div class="token-box">
				<mat-form-field>
					<input matInput [(ngModel)]="accessToken" autocomplete="off">
				</mat-form-field>
			</div>
		</div>
	</ng-template>

	<div class="error-message">
		<div>The token you provided is invalid.</div>
		<div class="additional-info">Please contact Customer Support at <strong>833.848.1100</strong> if you entered correctly.</div>
	</div>

	<div class="back-to-binder-button">
		<button mat-raised-button type="button" color="warn" (click)="backToBinderRequest()">Start Over</button>
		<button mat-raised-button type="button" color="primary" (click)="checkCustomerSupportToken()">Continue</button>
	</div>
</div>
<!-- binder sessions -->
 <div class="main-container binder-sessions"
 *ngIf="sections[SectionsEnum.BinderSessions] 
 	&& currentlyVisibleSection === SectionsEnum.BinderSessions && !isDataLoading" @fadeIn>
	<ul>
		<li *ngFor="let binderSession of binderSessions">
			<a mat-button color="primary" class="session-link" 
				(click)="onBinderSessionClick(binderSession)"
				[matTooltip]="binderSession.binderSessionName">
				{{ binderSession.binderSessionName }}
			</a>
			<div class="expiresOn">
				<ng-container *ngIf="binderSession.expiresOn">
					<mat-label class="label">Expires On: </mat-label>
					<span class="value">{{ binderSession.expiresOn | date }}</span>
				</ng-container>
			</div>
			<div class="years">
				<ng-container *ngIf="binderSession.years && binderSession.years.length > 0">
					<mat-label class="label">Years: </mat-label>
					<span class="value">
						<ng-container *ngFor="let year of binderSession.years; let i = index;">
							{{ year }}{{ binderSession.years.length - 1 !== i ? ', ' : '' }}
						</ng-container>
					</span>
				</ng-container>
			</div>
		</li>
	</ul>
	<div class="back-to-binder-button">
		<button mat-raised-button type="button" (click)="backToBinderRequest()">Go Back to Binder request</button>
	</div>
</div>
<app-loader [isInline]="true" *ngIf="isDataLoading"></app-loader>

<ng-template #infoTemplate let-label="label" let-text="text">
	<div class="item-details">
		<div class="item-details-text">
			<span class="label">{{ label }}</span>
			<span *ngIf="text">{{ text }}</span>
		</div>
	</div>
</ng-template>